/*
 * Copyright © 2017, Rezo Zero
 *
 * This file is part of Suprême NTM.
 *
 * Suprême NTM can not be copied and/or distributed without
 * the express permission of Rezo Zero.
 *
 * @file LyricPanelBlock.js
 * @author Adrien Scholaert <adrien@rezo-zero.com>
 * @copyright Rezo Zero 2018
 */

import {AbstractBlock} from 'starting-blocks'
import TweenMax from 'TweenMax'
import $ from 'jquery'
import {
    TRACK_CLICK
} from '../types/EventTypes'

export default class LyricsPanelBlock extends AbstractBlock {
    init () {
        super.init()

        /**
         * @type {jQuery}
         */
        this.$wrapper = this.$cont.find('#lyrics-panel__wrapper')

        /**
         * @type {jQuery}
         */
        this.$dynamicColumn = $('#dynamic-column')

        /**
         * @type {jQuery}
         */
        this.$body = $('body')

        /**
         * @type {jQuery}
         */
        this.$btnClose = this.$cont.find('.btn-close')

        this.state = {
            isOpen: false
        }

        // Binded methods
        this.onTrackClick = this.onTrackClick.bind(this)
        this.onDocumentClick = this.onDocumentClick.bind(this)
        this.hide = this.hide.bind(this)
    }

    initEvents () {
        super.initEvents()
        window.addEventListener(TRACK_CLICK, this.onTrackClick)
        window.addEventListener('click', this.onDocumentClick)
        this.$btnClose.on('click touch', this.hide)
    }

    destroyEvents () {
        window.removeEventListener(TRACK_CLICK, this.onTrackClick)
        window.removeEventListener('click', this.onDocumentClick)
        this.$btnClose.off('click touch', this.hide)
    }

    destroy () {
        this.hide()
        super.destroy()
    }

    onLoad () {
    }

    onResize () {
        super.onResize()
        this.setSize()
    }

    onPageReady () {
        this.setSize()
    }

    onDocumentClick (evt) {
        /**
         * @type {HTMLElement|Node|EventTarget}
         */
        let el = evt.target

        // Go up in the nodelist until we
        // find a track item
        while (el && !this.getTrack(el)) {
            el = el.parentNode
        }

        if (!el) {
            this.hide()
        }
    }

    getTrack (el) {
        if (!el) {
            return undefined
        }

        if ((' ' + el.className + ' ').replace(/[\n\t]/g, ' ').indexOf(' tracks__item ') > -1) {
            return el
        }

        if ((' ' + el.className + ' ').replace(/[\n\t]/g, ' ').indexOf(' lyrics-panel ') > -1) {
            return el
        }

        return undefined
    }

    onTrackClick ({ detail }) {
        if (this.currentTrack) {
            this.currentTrack.disable()
        }

        if (detail === this.currentTrack) {
            this.hide()
            this.currentTrack = null
            return
        }

        this.currentTrack = detail

        if (!this.state.isOpen) {
            this.open()
        }

        if (this.currentTrack.lyrics) {
            this.currentTrack.enable()
            this.setContent(this.currentTrack.lyrics)
        }
    }

    setContent (lyrics) {
        TweenMax.to(this.$wrapper, 0.25, {
            alpha: 0,
            onComplete: () => {
                this.$wrapper.html(lyrics)

                TweenMax.to(this.$wrapper, 0.25, {
                    alpha: 1
                })
            }
        })

        this.$cont.animate({
            scrollTop: 0
        }, 250)
    }

    open () {
        this.$body.addClass('lyrics-panel--open')
    }

    hide () {
        this.$body.removeClass('lyrics-panel--open')
    }

    setSize () {
        if (window.innerWidth > 992) {
            this.$cont.css({
                width: `calc(70% - 15px - ${this.$dynamicColumn.outerWidth()}px)`
            })
        } else if (window.innerWidth > 768) {
            this.$cont.css({
                width: `calc(90% - 15px - ${this.$dynamicColumn.outerWidth()}px)`
            })
        } else if (window.innerWidth > 576) {
            this.$cont.css({
                width: `calc(50vw)`
            })
        } else {
            this.$cont.css({
                width: `100%`
            })
        }
    }
}



// WEBPACK FOOTER //
// ./webpack/js/blocks/LyricsPanelBlock.js